import { css } from '@/styled-system/css';

export const adornedInputIconStyles = css.raw({
  width: 'icon.md',
  height: 'icon.md',
});
